import { render } from "./IndexDropdown.vue?vue&type=template&id=976dca62"
import script from "./IndexDropdown.vue?vue&type=script&lang=js"
export * from "./IndexDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yaakovbeckerman/projects/vue-notus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__